import React from 'react';
import PropTypes from 'prop-types';
import { DEVICE } from '@/constants';
import './style.less';

const S2 = ({ os }) => (
  <React.Fragment>
    <div className="butterfly" />
    <div className="leaf1" />
    <div className="leaf2" />
    <div className="leaf3" />
    <div className="leaf4" />
    <div className="leaf5" />
    <div className="leaf6" />
    { os !== DEVICE.MOBILE
      && (
        <React.Fragment>
          <div className="leaf7" />
          <div className="leaf8" />
        </React.Fragment>
      )
    }
    {os === DEVICE.PC && <div className="leaf9" />}
    <div className="camp" />
    <div className="boat" />
    <div className="car" />
    <div className="sun" />
    <div className="bear" />
  </React.Fragment>
);

S2.propTypes = {
  os: PropTypes.string,
};
export default S2;
